import type { FC } from 'react';
import { useMemo } from 'react';
import { Box, Button } from '@mui/material';

import { OrgUnitSelectionStatus } from 'src/constants/orgUnit';
import type {
  ModuleOrPlanActionOrgUnit,
  ModulePermissionOrgUnit,
  PlanActionPermissionOrgUnit,
} from 'src/types/orgUnit';
import useOrgTree from 'src/components/common/OrgTree/OrgTreeContext';

import { styles } from './index.styles';

export interface OrgUnitProps {
  createLabel: (...params: any[]) => any;
  onSelect: (orgUnit: ModuleOrPlanActionOrgUnit) => void;
  orgUnit: ModulePermissionOrgUnit | PlanActionPermissionOrgUnit;
}

const OrgUnit: FC<OrgUnitProps> = ({ createLabel, onSelect, orgUnit }) => {
  const { disableOrgUnitSelectionBasedOnStatus } = useOrgTree();

  // Temporary workaround because we have mixed snake_case and camelCase endpoint responses
  // TODO: unify the API responses to use a single format #1406
  const canNotSelect = useMemo(
    () =>
      (disableOrgUnitSelectionBasedOnStatus &&
        'selection_status' in orgUnit &&
        (orgUnit.selection_status ===
          OrgUnitSelectionStatus.LESS_THAN_MIN_RESPONDENT_AMOUNT ||
          orgUnit.selection_status ===
            OrgUnitSelectionStatus.NEGATIVE_SELECTION)) ||
      ('selectionStatus' in orgUnit &&
        (orgUnit.selectionStatus ===
          OrgUnitSelectionStatus.LESS_THAN_MIN_RESPONDENT_AMOUNT ||
          orgUnit.selectionStatus ===
            OrgUnitSelectionStatus.NEGATIVE_SELECTION)),
    [disableOrgUnitSelectionBasedOnStatus, orgUnit],
  );

  return (
    <Box key={orgUnit.id} sx={{ mt: 2 }}>
      <Button
        onClick={() => !canNotSelect && onSelect(orgUnit)}
        sx={styles.button(!canNotSelect)}
        variant="text"
        fullWidth
      >
        {createLabel({
          ...orgUnit,
          name:
            'search_name' in orgUnit && orgUnit.search_name
              ? orgUnit.search_name
              : orgUnit.name,
        })}
      </Button>
    </Box>
  );
};

export default OrgUnit;
